import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity, ClientEntity, TrialBalanceItem, Jaarrekening, Jaarrapportage, BokkzJrLogic
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { FeatureTaxReportDetailsComponent } from '../../tax-report-details/feature-tax-report-details.component';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from "rxjs";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-belastingen',
  templateUrl: './spec-belastingen.component.html',
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SpecTrialbalanceComponent,
    SpecFormattedexplanationComponent,
    CommonModule
  ],
  styleUrls: ['./spec-belastingen.component.scss']
})
export class SpecBelastingenComponent implements OnInit,OnChanges,OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public incomeTaxExpenseFg = {} as FormGroup;

  public deferredIncomeTaxExpenseFg = {} as FormGroup;
  public incomeTaxExpensePreviousFg = {} as FormGroup;
  public incomeTaxExpenseCurrentFg = {} as FormGroup;
  public incomeTaxExpenseOtherFg = {} as FormGroup;
  public incomeTaxExpenseDisclosureFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.incomeTaxExpenseFg = this.jrDataService.createFormGroupBalanceItem()
    this.deferredIncomeTaxExpenseFg = this.jrDataService.createFormGroupBalanceItem();
    this.incomeTaxExpensePreviousFg = this.jrDataService.createFormGroupBalanceItem();
    this.incomeTaxExpenseCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.incomeTaxExpenseOtherFg = this.jrDataService.createFormGroupBalanceItem();
    this.incomeTaxExpenseDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {

    const belastingen = value.rapportage?.jaarrekeningen?.at(0)?.winstEnVerliesrekening?.belastingen;

    if (belastingen) {
      this.incomeTaxExpenseFg.reset();

      if (belastingen.incomeTaxExpense) {
        this.incomeTaxExpenseFg.patchValue(belastingen.incomeTaxExpense, { emitEvent: false })
      }

      const uitsplitsing = belastingen.belastingenUitsplitsing;
      const tekstueel = belastingen.belastingenTekstueel;

      if (uitsplitsing) {
        if (uitsplitsing?.deferredIncomeTaxExpense) {
          const subItem = uitsplitsing.deferredIncomeTaxExpense;
          this.deferredIncomeTaxExpenseFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.deferredIncomeTaxExpenseFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.incomeTaxExpensePrevious) {
          const subItem = uitsplitsing.incomeTaxExpensePrevious;
          this.incomeTaxExpensePreviousFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.incomeTaxExpensePreviousFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.incomeTaxExpenseCurrent) {
          const subItem = uitsplitsing.incomeTaxExpenseCurrent;
          this.incomeTaxExpenseCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.incomeTaxExpenseCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.incomeTaxExpenseOther) {
          const subItem = uitsplitsing.incomeTaxExpenseOther;
          this.incomeTaxExpenseOtherFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.incomeTaxExpenseOtherFg.get('trialBalanceItems') as FormArray)
        }
      }
      if (tekstueel) {
        if (tekstueel.incomeTaxExpenseDisclosure) {
          this.incomeTaxExpenseDisclosureFg.patchValue(tekstueel.incomeTaxExpenseDisclosure);
        }
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i]);
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup);
        }
      }
    }
  }

  public saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
    this.deferredIncomeTaxExpenseFg.updateValueAndValidity();
    this.incomeTaxExpensePreviousFg.updateValueAndValidity();
    this.incomeTaxExpenseCurrentFg.updateValueAndValidity();
    this.incomeTaxExpenseOtherFg.updateValueAndValidity();
    this.incomeTaxExpenseDisclosureFg.updateValueAndValidity();

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        winstEnVerliesrekening: {
          ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening,
          belastingen: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.belastingen,
            belastingenUitsplitsing: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.belastingen?.belastingenUitsplitsing,
              deferredIncomeTaxExpense: this.deferredIncomeTaxExpenseFg.value,
              incomeTaxExpensePrevious: this.incomeTaxExpensePreviousFg.value,
              incomeTaxExpenseCurrent: this.incomeTaxExpenseCurrentFg.value,
              incomeTaxExpenseOther: this.incomeTaxExpenseOtherFg.value,
            },
            belastingenTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.belastingen?.belastingenTekstueel,
              incomeTaxExpenseDisclosure: this.incomeTaxExpenseDisclosureFg.value,
            }
          },
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogicService.getCalculation(this.jrEntity)

  }
}

